export default {
  data() {
    return {
      optionsStatus: [
        {
          item: "Quoted",
          text: "Quoted",
          value: true,
          disabled: false,
          info: ["unassigned", "quotes requested", "quotes received", "quoted"],
        },
        {
          item: "Assigned",
          text: "Assigned",
          value: true,
          disabled: false,
          info: ["tendered", "dispatched", "assigned"],
        },
        {
          item: "In Transit",
          text: "In Transit",
          value: true,
          disabled: false,
          info: ["in transit"],
        },
        {
          item: "Delivered",
          text: "Delivered",
          value: true,
          disabled: false,
          info: ["delivered", "completed"],
        },
        {
          item: "Cancelled",
          text: "Cancelled",
          value: true,
          disabled: false,
          info: ["expired", "declined", "cancelled"],
        },
      ],
    };
  },
  methods: {
    setLoadStatusColor(loadStatus) {
      const foundData = {
        color: "",
        label: "",
        border: "",
        backgroundColor: "",
      };
      const loadStatusString = loadStatus.toLowerCase();
      switch (loadStatusString) {
        case "unassigned":
          // Quoted
          foundData.label = "Quoted";
          foundData.color = "#6e8294";
          foundData.backgroundColor = "#ecf0f5";
          foundData.border = "#dde4ec";
          break;
        case "quotes requested":
          // Quoted
          foundData.label = "Quoted";
          foundData.color = "#6e8294";
          foundData.backgroundColor = "#ecf0f5";
          foundData.border = "#dde4ec";
          break;
        case "quotes received":
          // Quoted
          foundData.label = "Quoted";
          foundData.color = "#6e8294";
          foundData.backgroundColor = "#ecf0f5";
          foundData.border = "#dde4ec";
          break;
        case "quoted":
          // Quoted
          foundData.label = "Quoted";
          foundData.color = "#6e8294";
          foundData.backgroundColor = "#ecf0f5";
          foundData.border = "#dde4ec";
          break;
        case "pending":
          // Quoted
          foundData.label = "Truck Pending";
          foundData.color = "#6e8294";
          foundData.backgroundColor = "#ecf0f5";
          foundData.border = "#dde4ec";
          break;
        case "tendered":
          // Assigned
          foundData.label = "Assigned";
          foundData.color = "#0049ad";
          foundData.backgroundColor = "#ffffff";
          foundData.border = "#a8c6e3";
          break;
        case "assigned":
          // Assigned
          foundData.label = "Assigned";
          foundData.color = "#0049ad";
          foundData.backgroundColor = "#ffffff";
          foundData.border = "#a8c6e3";
          break;
        case "dispatched":
          // Assigned
          foundData.label = "Assigned";
          foundData.color = "#0049ad";
          foundData.backgroundColor = "#ffffff";
          foundData.border = "#a8c6e3";
          break;
        case "in transit":
          // In transit
          foundData.label = "In Transit";
          foundData.color = "#036e00";
          foundData.backgroundColor = "#eeffed";
          foundData.border = "#b3ffb2";
          break;
        case "delivered":
          // Delivered
          foundData.label = "Delivered";
          foundData.color = "#043663";
          foundData.backgroundColor = "#eef3f9";
          foundData.border = "#d6e3f0";
          break;
        case "completed":
          // Delivered
          foundData.label = "Delivered";
          foundData.color = "#043663";
          foundData.backgroundColor = "#eef3f9";
          foundData.border = "#d6e3f0";
          break;
        case "cancelled":
          // Cancelled
          foundData.label = "Cancelled";
          foundData.color = "#8C1D16";
          foundData.backgroundColor = "#fdecea";
          foundData.border = "#fad4cf";
          break;
        case "declined":
          // Cancelled
          foundData.label = "Cancelled";
          foundData.color = "#8C1D16";
          foundData.backgroundColor = "#fdecea";
          foundData.border = "#fad4cf";
          break;
        case "expired":
          // Cancelled
          foundData.label = "Cancelled";
          foundData.color = "#8C1D16";
          foundData.backgroundColor = "#fdecea";
          foundData.border = "#fad4cf";
          break;
        default:
          // Doesn't match
          foundData.label = "Invalid Load Status Type";
          foundData.color = "grey";
          foundData.backgroundColor = "#ecf0f5";
          break;
      }
      return foundData;
    },
    getStatusInfo(loadStatusString) {
      const statusMappings = {
        Quoted: ["unassigned", "quotes requested", "quotes received", "quoted"],
        Assigned: ["tendered", "dispatched", "assigned"],
        "In Transit": ["in transit"],
        Delivered: ["delivered", "completed"],
        Cancelled: ["expired", "declined", "cancelled"],
      };
      // eslint-disable-next-line no-restricted-syntax
      for (const statusItem in statusMappings) {
        if (statusMappings[statusItem].includes(loadStatusString)) {
          return { label: statusItem, color: this.getColorForStatus(statusItem) };
        }
      }
      return null;
    },
    getColorForStatus(status) {
      const colorMap = {
        Quoted: "#3a3a3a",
        Assigned: "#00ccff",
        "In Transit": "#ff6600",
        Delivered: "#336600",
        Cancelled: "#FF0A0A",
      };
      return colorMap[status] || "grey";
    },
  },
};
